import { toast } from 'react-toastify'

import { createApp } from 'utils/io'
import { defaultBranding } from 'utils/colors'
import { getNewAppWebSettings } from 'utils/webSettings'

export const submitCopyApp = (app, formValues) => {
  const {
    id: appId,
    branding = {},
    webSettings: sourceWebSettings,
    OrganizationId,
    useNewRNVersion,
    useNewArchitecture,
  } = app

  let { copyAsResponsive, appType, ...values } = formValues
  let mobileOnly = false

  if (appType) {
    copyAsResponsive = appType !== 'legacy'
    mobileOnly = appType === 'mobile'
  }

  const magicLayout = app?.magicLayout || copyAsResponsive

  const primaryPlatform = copyAsResponsive ? 'responsive' : app.primaryPlatform

  const webSettings = getNewAppWebSettings({
    sourceWebSettings,
    primaryPlatform,
    mobileOnly,
  })

  let opts = {
    ...values,
    branding: {
      ...defaultBranding,
      ...branding,
    },
    primaryPlatform,
    prototypeAppId: appId,
    magicLayout,
    webSettings,
    useNewRNVersion,
    useNewArchitecture,
  }

  if (values.copyDatabase === '0') {
    opts = {
      ...values,
      branding: {
        ...defaultBranding,
        ...branding,
      },
      primaryPlatform,
      datasourceAppId: appId,
      copyApp: true,
      copyDatabase: undefined,
      datasourceType: 'copy',
      magicLayout,
      webSettings,
      organizationId: OrganizationId,
      useNewRNVersion,
      useNewArchitecture,
    }
  }

  if (app.externalUsers?.enabled && app.externalUsers?.provider === 'xano') {
    opts.datasourceType = 'xano'
  }

  createApp(opts, error => {
    if (error) {
      toast.error(
        typeof error === 'string'
          ? error
          : 'Failed to copy app. Please try again.',
        {
          position: 'bottom-right',
          className: 'generic-error__toast',
          bodyClassName: 'generic-error__toast-body',
          hideProgressBar: true,
          autoClose: 5000,
        }
      )
    }
  })
}
